import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Link, useNavigate } from "react-router-dom";

export default function YourRecurringPaymentHasBeenUnsuccessful({ notification }) {
  const [club, setClub] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navi = useNavigate();
//styled
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${notification.clubId}`
      );

      if (clubResponse.status === 200) {
        setClub(clubResponse.data);

      
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // You can set error state here if needed
    } finally {
      setIsLoading(false); // Stop loading state in any case
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    if(club){
      return (
        <div className="container text-center bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2">Failed Payment Premium Club</p>
          </div>
          <p
            onClick={() => navi(`/club/${club.id}`)}
            className="fw-bold red-text pointer"
          >
            {club.name}
          </p>
          <div
            onClick={() => navi(`/club/${club.id}`)}
            className="circle-crop mx-auto"
          >
            <img
              src={
                club.image
                  ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                  : NoImagePlaceholder
              }
              alt="Club Image"
              className="mt-0 pointer"
            />{" "}
          </div>
          <p>{notification.content}</p>
          <a href={`${notification.url}`} className="saveChanges-button m-3">
            Payment Link
          </a>{" "}
          <br></br>
          <p className="mt-3">
            Note: The payment link above only resolves the current failed
            payment. The card used for this transaction will not automatically
            be set for future recurring payments unless it matches the original
            card. To update the card for this payment, visit{" "}
            <Link to="/MySubscriptionsAndTokens">Subscriptions and Tokens</Link>
            .
          </p>
        </div>
      );
    }else{
      return(
        <div>
          <p>Club not found</p>
        </div>
      )
    }
 
  }
}
